import React from 'react';

import { EMPTY_ARRAY } from 'common/constants';

import { Icon } from 'components';
import { Autocomplete } from 'e100-react-components';
import { IPropTypes as AutocompleteProps } from 'e100-react-components/lib/components/Autocomplete/types/props';

import { useIntl } from 'react-intl';
import { useStyles } from './styles';
import { useBoolState } from 'common/hooks';

export const Search = ({
  renderOption = ({ value }: any) => <div>{value}</div>,
  onChange,
  loadOptions,
  placeholder,
  defaultOptions = EMPTY_ARRAY
}: SearchProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const [ open,, setOpen ] = useBoolState();

  return (
    <div className={classes.container}>
      <Autocomplete
        autoComplete={false}
        multiple={false}
        autoHighlight={false}
        loadingText={`${formatMessage({ id: 'loading' })}...`}
        renderOption={renderOption}
        onChange={onChange}
        disablePortal
        loadOptions={loadOptions}
        filterOptions={item => item}
        defaultOptions={defaultOptions}
        noOptionsText={''}
        classes={{
          root: classes.root,
          inputRoot: classes.inputRoot,
          focused: classes.focused,
          popper: classes.popper,
          endAdornment: classes.endAdornment
        }}
        inputProps={{
          placeholder,
          InputProps: {
            startAdornment: <Icon
              kind={'search'}
              classes={{ root: classes.startAdornment }}
            />
          }
        }}
        disableClearable
        openOnFocus
        selectOnFocus
        disableCloseOnSelect
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={(_, reason) => {
          if (reason !== 'toggleInput') {
            setOpen(false);
          }
        }}
      />
    </div>
  );
}; 

export interface SearchProps extends Pick<
  AutocompleteProps,
  'renderOption' | 'onChange' | 'loadOptions'
> {
  placeholder?: string;
  defaultOptions?: any[];
}
